import React from 'react';
import SettingsDetails from './SettingsDetails';
import LicenseDetails from './LicenseDetails';
import CommonContainer from '../../../common/CommonContainer';
import withStyles from '@material-ui/core/styles/withStyles';
import { compose } from 'redux';
import { createStyles } from '@material-ui/core';

const styles = createStyles(theme => ({
  settingsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    flexWrap: 'wrap',
    width: '100%',
    '& > div': {
      minWidth: '45%',
    },
  },
}));

const SettingsPage = React.forwardRef((props, ref) => {
  
  const { classes } = props;
  return (<CommonContainer ref={ref} vAlign="center">
    <div className={classes.settingsWrapper}>
      <LicenseDetails />
      <SettingsDetails />
    </div>
  </CommonContainer>);
  
});

const decorate = compose(withStyles(styles));
export default decorate(SettingsPage);